import React from "react";
import ToolTip from "shared/components/tooltip";
import { ColumnHeaderWithTooltipProps } from "../table.types";

export default function ColumnHeaderWithTooltip(props: ColumnHeaderWithTooltipProps) {
  return (
    <span className={props.className}>
      {props.headerText}
      <ToolTip content={props.tooltipText} />
    </span>
  );
}
